import React, { useState, forwardRef, Ref, useImperativeHandle } from "react";
import CreatableSelect from "react-select/creatable";
import { ActionMeta, OnChangeValue } from 'react-select';
import { useEffect, useCallback } from "react";
import { EmitAndSemanticDiagnosticsBuilderProgram } from "typescript";

import "./styles.css";


// Inspired by https://dev.to/karan316/build-forms-using-react-the-easy-way-with-typescript-46bh

interface TableFormProps {
    tableid: string;
    table: any;
    file: any;
    facility: any; 
}


export interface TableFormObject {
    getSettings: () => {}
};

interface Option {
  readonly label: string;
  readonly value: string;
}

interface State {
  ignoreTable: boolean;
  facility: any;
  facilityId: string;
  facilityName: string;
  file: any;
  table: any;
  date1: string;
  date2: string;
  payer: string;
  setting: string;
  ignoreReason: OnChangeValue<Option, false>;
  puntedReason: OnChangeValue<Option, false>;
}

const emptybuild: State = {
  ignoreTable: false,
  facility: {name: '', city: '', state: '', actualurl: ''},
  facilityId: '',
  facilityName: '',
  file: {sourceurl: '', storage: ''},
  table: {tableid: '', format: '', location: '', initialrow: 0, height: 0, lastupdatedon: ''},
  date1: '',
  date2: '',
  payer: '',
  setting: '',
  ignoreReason: null,
  puntedReason: null
};

const createOption = (label: string, value: string) => ({
  label,
  value: value
});

const defaultIgnoreOptions: Option[] =  [
  createOption( "Table Does Not Contain Pricing Information",
		"Table Does Not Contain Pricing Information"),
  createOption( "No Column Names", "No Column Names"),
  createOption( "Missing Required Column(s)", "Missing Required Column(s)"),
  createOption( "Missing Description Column", "Missing Description Column"),
  createOption( "Missing a Code Column", "Missing a Code Column"),
  createOption( "No Payer Specified Corresponding to Negotiated Charges",
		"No Payer Specified Corresponding to Negotiated Charges"),
  createOption( "Bad Column Names", "Bad Column Names"),
  createOption( "Too Many Column Name Rows", "Too Many Column Name Rows"),
  createOption( "Negotiated Charges are Min, Max, or Avg. for Single Payer",
		"Negotiated Charges are Min, Max, or Avg. for Single Payer"),
  createOption( "Almost All Charge Values Invalid",
		"Almost All Charge Values Invalid"),
  createOption( "Malformed Table",
		"Malformed Table"),
  createOption( "Charge Values are Not Numeric", "Charge Values are Not Numeric")
];

const defaultPuntedOptions: Option[] = [
  createOption( "Weird Table", "Weird Table"),
  createOption( "Strange Columns", "Strange Columns")
];


const currentbuild: State = {
  ignoreTable: false,
  facility: {name: '', city: '', state: '', actualurl: ''},
  facilityId: '',
  facilityName: '',
  file: {sourceurl: '', storage: ''},
  table: {tableid: '', format: '', location: '', initialrow: 0, height: 0, lastupdatedon: ''},
  date1: '',
  date2: '',
  payer: '',
  setting: '',
  ignoreReason: null,
  puntedReason: null
};

function build(initialSettings: any, tagging: any): any {
    let state: any = {};

    if (!initialSettings.table) {
        console.log('***** No settings for build *****');
    }
  if (initialSettings.table) {
    const options = JSON.parse(initialSettings.table.options);

    const edited = options.edited;

    const facility = initialSettings.facility;
    const file = initialSettings.file;
    const table = initialSettings.table;

    let ignoreTable = false;
    let facilityId = facility ? facility.facilityid : '';
    let facilityName = facility ? facility.name : '';
    let date1 = '';
    let date2 = '';
    let payer = '';
    let setting = '';
    let ignoreReason = null;
    let puntedReason = null;
    
    if (edited) {
      payer = edited.payer;
      date1 = edited.dates[0];
      date2 = edited.dates[1];
      setting = edited.setting ? edited.setting : '';
      facilityId = edited.facilityId;
      facilityName = edited.facilityName;
      ignoreTable = edited.ignoreTable;
      ignoreReason = edited.ignoreReason ? createOption(edited.ignoreReason, edited.ignoreReason) : null;
      puntedReason = edited.puntedReason ? createOption(edited.puntedReason, edited.puntedReason)  : null;
    }
    // Prefer the values stored in the tagging.
    // Note that not all fields are stored by tagging e.g. facilityid and facilityName are no longer stored.
    if (tagging) {
      let dates = JSON.parse(tagging.dates);
      payer = tagging.payer;
      date1 = dates[0];
      date2 = dates[1];
      setting = tagging.setting ? tagging.setting : '';
      ignoreTable = tagging.ignore_table;
      ignoreReason = tagging.ignore_reason ? createOption(tagging.ignore_reason, tagging.ignore_reason) : null;
      puntedReason = tagging.punted_reason ? createOption(tagging.punted_reason, tagging.punted_reason)  : null;
    }
    if (setting == 'inpatient/outpatient') {
      setting = 'IP/OP';
    }

    currentbuild.ignoreTable = ignoreTable;
    currentbuild.table = table;
    currentbuild.file = file;
    currentbuild.facilityId = facilityId;
    currentbuild.facilityName = facilityName;
    currentbuild.date1 = date1;
    currentbuild.date2 = date2;
    currentbuild.payer = payer;
    currentbuild.setting = setting;
    currentbuild.ignoreReason = ignoreReason;
    currentbuild.puntedReason = puntedReason;
  }
  //console.log('currentbuild', currentbuild);
  return currentbuild;
}


// function TableForm<TableFormProps>({tableid, table, file, facility}) {
// Added a ref so the editor can retrieve data from the grid at any time.
// See: https://stackoverflow.com/questions/60554808/react-useref-with-typescript-and-functional-component

// const TableForm: React.FC<TableFormProps> = ({tableid, table, file, facility}) => {
const TableForm = forwardRef((props: {initialSettings: any, initialtableid: any, tagging: any/*, tableid: any, table: any, file: any, facility: any*/}, ref: Ref<TableFormObject>) => {  
   // const [facilityid, setFacilityid] = useState(facility ? facility.facilityid : null);
  const {initialSettings, initialtableid/*, tableid, table, file, facility*/} = props;

  let tagging: any = null;
  if (props.tagging) {
    tagging = props.tagging;
  }

  const [tableid, setTableid] = useState('');
  const [values, setValues] = useState(emptybuild); // useState(build(initialSettings)); // currentbuild);
  // Save the state of the options for the ignoreReason
  const [ignoreOptions, setIgnoreOptions] = useState(defaultIgnoreOptions); // useState(build(initialSettings)); // currentbuild);
  const [puntedOptions, setPuntedOptions] = useState(defaultPuntedOptions); // useState(build(initialSettings)); // currentbuild);

   // console.log('values are now', values);

    useEffect(() => {
        // Update the settings when the props change
        if (initialtableid && tableid != initialtableid) {
            setTableid(initialtableid);
          setValues(build(initialSettings, tagging));
        }
    });

    // console.log('initial values', values);

    useImperativeHandle(ref, () => ({ getSettings }));  

  const getSettings = () => {
      return {
        ignoreTable: values.ignoreTable,
        facilityId: values.facilityId,
        facilityName: values.facilityName,
        dates: [values.date1, values.date2],
        payer: values.payer,
        setting: values.setting,
	ignoreReason: (values?.ignoreReason?.value) ? values.ignoreReason.value : '',
	puntedReason: (values?.puntedReason?.value) ? values.puntedReason.value : ''
      }
  }

    // console.log('+++++ new initial state', initialState);
 
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = (event.target.type === 'checkbox') ? event.target.checked : event.target.value;
        console.log('onChange', name, value);
        setValues({ ...values, [name]: value });

        console.log('Values', values);
    };

    const onSettingChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log('onSettingChange', name, value);
        setValues({ ...values, [name]: value });
    }

    const onSubmit = async (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        console.log('onSubmit', event);

        //TODO Submit results
    };

/*
  const handleIgnoreCreate = useCallback(
    (inputValue: OnChangeValue<Option, false>, actionMeta: ActionMeta<Option> ) => {
      const newValue = { value: inputValue.toLowerCase(), label: inputValue };
      setIgnoreOptions([...ignoreOptions, newValue]);
      setValues({ ...values, ['ignoreReason']: inputValue });
    },
    [ignoreOptions]
  );
*/

  const handleIgnoreChange = (inputValue: OnChangeValue<Option, false>, actionMeta: ActionMeta<Option> ) => {
    setValues({ ...values, ignoreReason: inputValue });
  };


  const handlePuntedChange = (inputValue: OnChangeValue<Option, false>, actionMeta: ActionMeta<Option> ) => {
      setValues({ ...values, puntedReason: inputValue });
  };

  const ignoreReasonStyles = {
    container: (provided: any) => ({
      ...provided,
      width: 250,
      fontSize: "14px"
    })
  };

  const puntedReasonStyles = {
    container: (provided: any) => ({
      ...provided,
      width: 350,
      fontSize: "14px"
    })
  };

    // a submit function that will execute upon form submission
    async function loginUserCallback() {
        // send "values" to database
    }

    // const facilityid = (facility && facility.facilityid) ? facility.facilityid : null
   
    function renderFacilityInfo() {
        if (values.facility) {
            return (
                <div className='info-block'><b>Facility</b><br/>
                <span>{values.facility.name}</span>
                <span>&nbsp;&nbsp;{values.facility.city}</span>
                <span>&nbsp;{values.facility.state}</span>
                <div>{values.facility.actualurl}</div>
                </div>
            );
        }
    }

    function renderFileInfo() {
        if (values.file) {
            return (
                <div className="info-block"><b>File</b><br/>
                <span className="info-label">Storage:</span><span className="info-value"> {values.file.storage}</span><br/>
                <span className="info-label">Url:</span><span className="info-value"> <a href={values.file.sourceurl} target="_blank">{values.file.sourceurl}</a></span>
                </div>
            );            
        }
    }

    function renderTableInfo() {
        if (values.table) {
            return (
                <div className="info-block"><b>Table</b><br/>
                <span className="info-label">Format:</span><span className="info-value">{values.table.format}</span>
                <span className="info-label">Location/Tab:</span><span className="info-value">{values.table.location}</span><br/>
                <span className="info-label" id="tableid-info">Table Id:</span><span className="info-value">{values.table.tableid}</span>
                <span className="info-label" id="updated-info">Last Updated:</span><span className="info-value">{values.table.lastupdatedon}</span>
                <span className="info-label">Initial row:</span><span className="info-value">{values.table.initialrow}</span>
                <span className="info-label">Height:</span><span className="info-value">{values.table.height}</span>
                </div>
            );
        }
    }

    return (
        // don't mind this ugly form :P
        <div id="table_form_div" style={{textAlign:'left'}}>
        {renderFacilityInfo()}
        {renderFileInfo()}
        {renderTableInfo()}

        <form id="table_form" onSubmit={onSubmit}>
        <div>
            <input
                style={{margin: 5}}
                name='facilityId'
                id='facilityId'
                type='facilityId'
                placeholder='Facility Identifier'
                value={values.facilityId}
                onChange={onChange}
                />

            <input
                style={{margin: 5}}
                name='facilityName'
                id='facilityName'
                type='facilityName'
                placeholder='Facility Name'
                value={values.facilityName}
                onChange={onChange}
                />

            <input
                style={{margin: 5}}
                name='date1'
                id='date1'
                type='date1'
                placeholder='Date'
                value={values.date1}
                onChange={onChange}
                />

            <input
                style={{margin: 5}}
                name='date2'
                id='date2'
                type='date2'
                placeholder='Second Date'
                value={values.date2}
                onChange={onChange}
                />
	    <br/>
            <input
                style={{margin: 5}}
                name='ignoreTable'
                id='ignoreTable'
                type='checkbox'
                placeholder='Ignore Table'
                checked={values.ignoreTable}
                onChange={onChange}/><span className="info-label"> Ignore Table</span>
	<span className="info-label" id="ignore-reason">Reason ignored:</span>
	<div className="select-wrapper">
	<CreatableSelect
      isClearable
      styles={ignoreReasonStyles}
      value={values.ignoreReason}
      placeholder="Select or enter a reason..."
      options={defaultIgnoreOptions}
      onChange={handleIgnoreChange}
      /></div>
	<span className="info-label" id="punted-reason">Reason skipped:</span>
	<div className="select-wrapper">
	<CreatableSelect
      isClearable
      styles={puntedReasonStyles}
      value={values.puntedReason}
      placeholder="Select or enter a skip reason..."
      options={defaultPuntedOptions}
      onChange={handlePuntedChange}
      /></div>

	<br/>
	<span className="info-label">Payer Name for Table:</span> <input
                style={{margin: 5}}
                name='payer'
                id='payer'
                type='payer'
                placeholder='Fixed Payer Name'
                value={values.payer}
                onChange={onChange}
                />

            	<span className="info-label">Setting for Table:</span>
            <select name='setting' value={values.setting} onChange={onSettingChange}>
                <option value=""></option>
                <option value="inpatient">Inpatient</option>
                <option value="outpatient">Outpatient</option>
                <option value="IP/OP">Inpatient/Outpatient</option>
            </select>

            {/* <button type='submit'>Submit</button> */}
        </div>
        </form>
        </div>
    );
});

export default TableForm;
